import React, { useEffect, useState } from 'react'
import { onWarning } from '../messages'
import { useTextResources } from '../../../language';
import PropTypes from "prop-types";
import { UserHasPermission } from '../permissionsActions';

const ValidateModalPermission = ({ open, onClose, actionId, noPermissionMessage, children }) => {
    const [hasPermission, setHasPermission] = useState(false)
    const text = useTextResources()
    let validateIfHasPermission = false;

    useEffect(() => {
        if (window.optima?.user?.ActionIDs?.length > 0 || window.SelfieSettings?.settings?.user?.actions) {
            validateIfHasPermission = UserHasPermission(actionId);
        }
        
        if (hasPermission != validateIfHasPermission) {
            setHasPermission(validateIfHasPermission);
        }

        if (open) {
            if (!validateIfHasPermission) {
                onWarning(noPermissionMessage || text('NoPermission'));
                if (onClose) onClose();
            }
        }
    }, [open])

    return hasPermission && <>{children}</>
}

ValidateModalPermission.propTypes = {
    children: PropTypes.any,
    actionId: PropTypes.number,
    rest: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    noPermissionMessage: PropTypes.string
}

export default ValidateModalPermission